// extracted by mini-css-extract-plugin
export default {"value":"CalculationSection_value__qih-0","wrapper":"CalculationSection_wrapper__AnJgl"};